<template>
  <div>
    <AppBar />
    <v-main>
      <v-row v-if="isDebug" justify="center">
        <v-col class="text-caption text-left : text-body1 text-left" cols="11">
          <template>
            <v-container class="u-pre-wrap">
              <v-subheader class="text-left text-xl-h5 text-lg-h5 text-md-h5 text-sm-h6">
                <v-btn icon @click="isDebugOpen = !isDebugOpen">
                  <v-icon>
                    {{ isDebugOpen?'mdi-chevron-up':'mdi-chevron-down' }}
                  </v-icon>
                </v-btn>
                デバッグ用情報（クリックで詳細オープン）
              </v-subheader>
              <v-divider />
              <div v-if="isDebugOpen" class="pa-9" style="word-wrap:break-word; text-align:left;">
                <b>location.origin: </b>{{ url }} <br />
                <b>IsSignedIn: </b>{{ isSignedIn }} <br />
                <b>user: </b>{{ $store.state.user }} <br />
                <b>userFromLocalStorage: </b>{{ userFromLocalStorage }} <br />
                <b>registCourseId: </b>{{ $store.state.registCourseId }} <br />
                <b>registCourseIdFromLocalStorage: </b>{{ $store.state.registCourseId }} <br />
                <b>idToken: </b>{{ $store.state.idToken }} <br />
                <div v-if="$store.state.idToken===idTokenFromLocalStorage">
                  <b>idTokenFromLocalStorage: </b>idTokenと値が一致しています。<br />
                </div>
                <div v-else>
                  <b>idTokenFromLocalStorage: </b>{{ idTokenFromLocalStorage }} <br />
                </div>
                <b>accessToken: </b>{{ $store.state.accessToken }} <br />
                <div v-if="$store.state.accessToken===accessTokenFromLocalStorage">
                  <b>accessTokenFromLocalStorage: </b>accessTokenと値が一致しています。<br />
                </div>
                <div v-else>
                  <b>accsessTokenFromLocalStorage: </b>{{ accessTokenFromLocalStorage }} <br />
                </div>
                <b>username: </b>{{ $store.state.username }} <br />
                <b>currentUnit: </b>{{ $store.state.currentUnit }} <br />
                <b>currentLesson: </b>{{ $store.state.currentLesson }} <br /><br />
              </div>
              <div class="ma-4 pl-10">
                <v-row>
                  <v-col cols="6">
                    <router-link to="/all-course-list">
                      <span>
                        all-course-listに移動
                      </span>
                    </router-link>
                  </v-col>
                  <v-col cols="6">
                    <span v-if="isQuestionRandom">
                      解答テストのランダマイズ：有効
                    </span>
                    <span v-else>
                      解答テストのランダマイズ：無効
                    </span>
                  </v-col>
                </v-row>
              </div>
              <!-- <router-link to="/katex">
                katexテストページに移動
              </router-link><br /> -->

              <v-divider />
            </v-container>
          </template>
        </v-col>
      </v-row>
      <v-container v-if="$vuetify.breakpoint.width < 375">
        PlatJaMはこの画面サイズの表示に対応していません。モバイル端末の場合は、画面を回転させて横長表示にすると表示できる場合があります。
      </v-container>
      <v-container v-else fluid>
        <router-view />
      </v-container>
    </v-main>
    <AppFooter />
  </div>
</template>

<script>
import repository from '@/store/repository'
import AppBar from '@/components/single/AppBar.vue'
import AppFooter from '@/components/single/AppFooter.vue'

export default {
  name: 'Top',
  components: {
    AppBar,
    AppFooter
  },
  data () {
    return {
      isDebugOpen: false,
      name: '',
      url: location.origin
    }
  },
  computed: {
    isDebug: function () {
      return repository.isDebug()
    },
    isQuestionRandom: function () {
      return repository.isQuestionRandom()
    },
    isSignedIn: function () {
      return repository.isSignedIn()
    },
    idTokenFromLocalStorage: function () {
      return repository.getIdToken()
    },
    accessTokenFromLocalStorage: function () {
      return repository.getAccessToken()
    },
    courseId: function () {
      return repository.getRegistCourseId()
    },
    userFromLocalStorage: function () {
      return repository.getPjmUserId()
    }
  },
  watch: {
    $route: function (to, from) {
      this.name = this.$route.name
    }
  },
  mounted () {
    this.name = this.$route.name
  }
}
</script>

<style scoped>
/* .left {
  text-align: left;
} */
</style>
